import { Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { useBeforeUnload, useBlocker } from "react-router-dom";

enum BlockerState {
  Blocked = "blocked",
  Unblocked = "unblocked",
  Proceeding = "proceeding",
}
interface IProps {
  isBlocking: boolean;
  title?: string;
  cancelText?: string;
  okText?: string;
  onOk(): void;
  message?: string;
}

const BlockingPopupModal = ({
  isBlocking,
  title,
  cancelText,
  okText,
  onOk,
  message,
}: IProps) => {
  const blocker = useBlocker(isBlocking);

  //Handles Browser refresh or leaving the site
  useBeforeUnload((event) => {
    if (isBlocking) {
      event.preventDefault();
      event.returnValue = ""; // Required for some browsers
    }
  });

  const handleOkClick = () => {
    onOk();

    if (blocker.state === BlockerState.Blocked) {
      blocker.proceed();
    }
  };

  return (
    <>
      {blocker.state === BlockerState.Blocked ? (
        <Modal
          title={title}
          open={true}
          cancelText={cancelText ?? <FormattedMessage id={"general.cancel"} />}
          okText={okText ?? <FormattedMessage id={"general.ok"} />}
          onOk={handleOkClick}
          onCancel={() => blocker.reset()}
        >
          <p>{message}</p>
        </Modal>
      ) : null}
    </>
  );
};

export { BlockingPopupModal };
